import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { HeaderComponent } from "../../../../../header/header.component";
import { ActionButtonComponent } from "../../../../../action-button/action-button.component";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "rask-map-popup-content",
    templateUrl: "./map-popup-content.component.html",
    styleUrls: ["./map-popup-content.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        ActionButtonComponent,
        NgbTooltip
    ]
})
export class MapPopupContentComponent {

    @Input() canEdit: boolean;
    @Input() allowDelete = true;
    @Input() abort = () => {
        //
    };
    @Input() edit = () => {
        //
    };
    @Input() delete = () => {
        //
    };

}
